export default "__VITE_ASSET__Fwyj6oq8__"